<combobox>
    <div>
        <my-label if="{ props.label }" ckey="{ props.ckey }" label="{ props.label }"></my-label>
        <div class="{ props.label ? 'mt-2' : '' } grid grid-cols-1">
            <select id="{ props.ckey }" name="{ props.ckey }" required="{ props.is_required }" onchange="{
                        select_item
                    }" class="bg-none col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                <option if="{ props.placeholder }" value="">{ props.placeholder }</option>
                <option each="{ item in state.filtered_items }" value="{ item.value }" selected="{ item.value == props.value }">{ item.label }</option>
            </select>
            <svg class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon">
            <path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
            </svg>
        </div>
    </div>


    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS } from '/src/utils/constants'

        export default {

            onBeforeMount(props, state) {
                this.state = {
                    items: [],
                    depending_items: [],
                    filtered_items: [],
                    item_selected: '',
                    item_selected_value: ''
                }
                eventBus.on(EVENTS.COMBOBOX.UPDATE, this.handleUpdateCombobox)
                eventBus.on(EVENTS.COMBOBOX.SELECTED, this.handleSelectedCombobox)
                eventBus.on(EVENTS.COMBOBOX.RESET, this.handleResetCombobox)
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.COMBOBOX.UPDATE, this.handleUpdateCombobox)
                eventBus.off(EVENTS.COMBOBOX.SELECTED, this.handleSelectedCombobox)
                eventBus.off(EVENTS.COMBOBOX.RESET, this.handleResetCombobox)
            },

            handleUpdateCombobox(e) {
                if (e.ckey === this.props.ckey) {
                    if (this.props.depends_on) {
                        this.update({
                            items: e.items,
                            depending_items: [],
                            filtered_items: []
                        })
                    } else {
                        this.update({
                            items: e.items,
                            depending_items: e.items,
                            filtered_items: e.items
                        })
                    }
                }
            },

            handleSelectedCombobox(e) {
                if (e.ckey === this.props.depends_on) {
                    const items = this.state.items.filter(
                            item => item.depending === e.value
                    )
                    this.update({
                        depending_items: items,
                        filtered_items: items,
                        item_selected: '',
                        item_selected_value: ''
                    })
                }
            },

            handleResetCombobox(e) {
                if (e.ckey === this.props.ckey) {
                    this.reset_item();
                }
            },

            select_item(e) {
                eventBus.trigger(EVENTS.COMBOBOX.SELECTED, {
                    ckey: this.props.ckey,
                    value: e.target.value
                })
            },

            reset_item() {
                this.update({
                    item_selected: '',
                    item_selected_value: '',
                    filtered_items: this.state.depending_items.length ? this.state.depending_items : this.state.items
                });
                this.$("select").value = "" // Resetta visivamente il valore del select
            }
        }
    </script>
</combobox>